import AddIcon from '@mui/icons-material/Add'
import { Button, Checkbox, Divider, Grid, Typography } from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { SelectInput, TextFieldLabel } from 'src/components/UI'
import BackButton from 'src/components/UI/CustomUI/atoms/BackButton'
import { repairItemActions } from 'src/ducks/actions'
import { getRepairlistFilter } from 'src/ducks/filters/selector'
import { MaterialItem } from 'src/ducks/types'
import { ITEM_CATEGORY_OPTIONS, SEVERITY_OPTIONS } from 'src/helpers'
import Alert from '../Alert'
import MaterialTable from '../MaterialTable'
import MaterialModal from '../Modals/MaterialModal'
import useStyles from '../styles'

const NewPriceItem = () => {
  const dispatch = useDispatch()

  const styles = useStyles()

  const [open, setOpen] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const [newPriceItem, setNewPriceItem] = useState<any>({})
  const [materials, setMaterials] = useState<MaterialItem[]>([])

  const repairListFilter = useSelector(getRepairlistFilter())

  const {
    title,
    disclaimer,
    category,
    laborRate,
    severity,
    unitMaterialCost,
    unitLaborHours,
    hideFromClient,
    unitPrice,
    margin,
    unitCost,
  } = newPriceItem

  const handleAddMaterial = () => {
    setOpen(true)
  }

  const handleUpdatePriceItem = (item: any) => {
    setNewPriceItem({ ...newPriceItem, ...item })
  }

  const handleCreateMaterial = (newMaterial: MaterialItem) => {
    setMaterials([...materials, newMaterial])
  }

  const handleSave = () => {
    setLoading(true)
    dispatch(
      repairItemActions.createRepairItem(
        {
          title,
          category: category || 'UNCATEGORIZED',
          disclaimer: disclaimer || '',
          severity,
          hideFromClient,
          laborHours: Number(unitLaborHours),
        },
        (succ) => {
          if (succ) {
            dispatch(
              repairItemActions.patchPriceItem({
                request: {
                  title,
                  margin: Number(margin),
                  unitCost: Number(unitCost),
                  unitPrice: Number(unitPrice),
                  unitLaborHours: Number(unitLaborHours),
                  unitMaterialCost: Number(unitMaterialCost),
                  category: category || 'UNCATEGORIZED',
                  severity: severity || '',
                  disclaimer: disclaimer || '',
                  materials: materials.map((mat) => ({
                    id: mat.id,
                    quantity: 1,
                  })),
                  laborRate: Number(laborRate),
                },
                territoryId: repairListFilter.territory?.key || '',
              }, (succ) => {
                if(succ) {
                  toast.success('Successfully created repair item')
                }
                setLoading(false)
              })
            )
          }
        }
      )
    )
  }
  
  return (
    <>
      <BackButton float top="25px" />
      <Grid container spacing={2} flexDirection="column">
        <Grid item container className={styles.header} flexDirection="column">
          <Typography className={styles.title}>
            {title || 'Item Title'}
          </Typography>
          <Typography className={styles.subtitle}>{`Estimate Item For ${repairListFilter.territory?.label || 'All Territories'
            }`}</Typography>
        </Grid>
        <Grid item>
          <Alert warningText={`If the margin isn't 100%, the customer's price is calculated based on the cost and margin. In those cases, make sure the cost isn't 0.`} text="New Price Items will be available for all territories. The price specified at creation will be the default for all territories. You can override the price for each territory. Title, Disclaimer, Category, Severity, labor hours and hide from client changes will apply to all territories." />
        </Grid>
        <Grid item container spacing={2}>
          <Grid item container spacing={2} flexDirection="column" xs={6}>
            <Grid item>
              <Typography className={styles.contentTitle}>
                ITEM INFORMATION
              </Typography>
            </Grid>
            <Grid item>
              <TextFieldLabel
                label="Display Title"
                value={title}
                onChange={(e: any) =>
                  handleUpdatePriceItem({ title: e.target.value })
                }
              />
            </Grid>
            <Grid item>
              <TextFieldLabel
                isTextArea
                autoComplete="off"
                label={
                  <Typography display="inline" variant="h6">
                    Display Disclaimer
                  </Typography>
                }
                placeholder="Display Disclaimer"
                value={disclaimer || ''}
                size="small"
                onChange={(newSelected) =>
                  handleUpdatePriceItem({ disclaimer: newSelected.target.value })
                }
                inputProps={{ style: { fontSize: '14px' } }}
                multiline
                textFieldStyle={{ fontSize: '14px' }}
                labelVariant="h6"
              // disabled={vendorIsPaid}
              />
              {/* <SelectInput
                label="Display Disclaimer"
                placeholder="Disclaimer Text"
                value={disclaimerArray || []}
                options={DISCLAIMER_OPTIONS.map((option) => option.value)}
                size="small"
                onChange={(newSelected) =>
                  handleUpdatePriceItem({ disclaimer: newSelected })
                }
                onBlur={_handleBlur}
                clearOnBlur
                multiple
                freeSolo
                labelVariant="h6"
                maxCharacters={40}
              // disabled={vendorIsPaid}
              /> */}
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <SelectInput
                  label="Category"
                  // disabled
                  value={category}
                  options={ITEM_CATEGORY_OPTIONS.map((option) => option)}
                  onChange={(newValue) => handleUpdatePriceItem({ category: newValue.label })}
                  size="small"
                  labelVariant="h6"
                />
              </Grid>
              <Grid item xs={6}>
                <SelectInput
                  label="Severity: "
                  // disabled
                  value={severity || ''}
                  onChange={(newValue) =>
                    handleUpdatePriceItem({ severity: newValue.label })
                  }
                  options={SEVERITY_OPTIONS}
                  size="small"
                  labelVariant="h6"
                />
              </Grid>
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <TextFieldLabel
                  label="Material Cost"
                  value={unitMaterialCost?.toString()}
                  onChange={(e: any) => {
                    handleUpdatePriceItem({ unitMaterialCost: e.target.value })
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextFieldLabel
                  label="Labor Hours"
                  value={unitLaborHours?.toString()}
                  onChange={(e: any) =>
                    handleUpdatePriceItem({ unitLaborHours: e.target.value })
                  }
                />
              </Grid>
            </Grid>
            <Grid item container spacing={2}>
              <Grid item container alignItems="center" width="fit-content">
                <Typography>Hide from Client</Typography>
                <Checkbox
                  checked={!!hideFromClient}
                  onChange={() =>
                    handleUpdatePriceItem({ hideFromClient: !hideFromClient })
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item container spacing={2} flexDirection="column" xs={6}>
            <Grid item>
              <Typography
                className={styles.contentTitle}
                textTransform="uppercase"
              >
                territory specific:{' '}
                {repairListFilter.territory?.label || 'All Territories'}
              </Typography>
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={3}>
                <TextFieldLabel
                  label="Price"
                  value={unitPrice}
                  onChange={(e) =>
                    handleUpdatePriceItem({ unitPrice: e.target.value })
                  }
                  prefix="$"
                />
              </Grid>
              <Grid item xs={3}>
                <TextFieldLabel
                  label="Margin %"
                  value={margin}
                  textFieldStyle={{ borderColor: margin === '100' ? '' : 'var(--red700)' }}
                  onChange={(e) =>
                    handleUpdatePriceItem({ margin: e.target.value })
                  }
                  prefix="$"
                />
              </Grid>
              <Grid item xs={3}>
                <TextFieldLabel
                  label="Cost"
                  value={unitCost}
                  onChange={(e) =>
                    handleUpdatePriceItem({ unitCost: e.target.value })
                  }
                  prefix="$"
                />
              </Grid>
              <Grid item xs={3}>
                <TextFieldLabel
                  label="Labor Rate"
                  value={laborRate}
                  onChange={(e) =>
                    handleUpdatePriceItem({ laborRate: e.target.value })
                  }
                  prefix="$"
                />
              </Grid>
            </Grid>
            <Grid item>
              <Button
                className={styles.submitBtn}
                style={{ backgroundColor: !unitPrice || !margin || !unitCost || !laborRate || !unitMaterialCost || !unitLaborHours || !title || loading ? '#EBECEF' : 'var(--green700)' }}
                disabled={!unitPrice || !margin || !unitCost || !laborRate || !unitMaterialCost || !unitLaborHours || !title || loading}
                onClick={handleSave}>
                {loading ? 'Saving...' : 'Save Price Item'}
              </Button>
            </Grid>
            <Grid item>
              <Divider orientation="horizontal" />
            </Grid>
            <Grid
              item
              container
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography className={styles.contentTitle}>
                Territory Materials:{' '}
                {repairListFilter.territory?.label || 'All Territories'}
              </Typography>
              <Button
                className={styles.addBtn}
                endIcon={<AddIcon style={{ width: '14px', height: '14px' }} />}
                onClick={handleAddMaterial}
              >
                Add Material
              </Button>
            </Grid>
            <Grid item>
              <MaterialTable materials={materials} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <MaterialModal
        open={open}
        setOpen={setOpen}
        isNewPriceItem={true}
        onCreateMaterial={handleCreateMaterial}
      />
    </>
  )
}

export default NewPriceItem
